"use client"

import LoginWrapper from "features/login/LoginWrapper"

import { Box, Center, Link, VStack } from "@chakra-ui/react"
import { useColorMode } from "@chakra-ui/system"
import { ClerkLoaded, ClerkLoading, SignedOut, SignIn } from "@clerk/nextjs"
import { dark } from "@clerk/themes"

import LoginSkeleton from "../LoginSkeleton"

import type * as React from "react"

const LoginScreen = (): React.ReactElement => {
    const { colorMode } = useColorMode()

    return (
        <LoginWrapper>
            <ClerkLoaded>
                <Center className='h-full w-full min-h-full'>
                    <VStack>
                        <SignedOut>
                            <SignIn
                                path='/login'
                                routing='path'
                                appearance={{
                                    elements: {
                                        cardBox: "shadow-none rounded-none min-w-fit border-none",
                                        card: "shadow-none rounded-none border-none p-0 dark:bg-transparent",
                                        logoBox: "justify-start mb-4",
                                        headerTitle: "text-left text-2xl mb-2",
                                        headerSubtitle: "text-left text-md",
                                        formButtonPrimary: "shadow-none py-3 text-md",
                                        footer: "mt-4 mb-4 bg-white p-0"
                                    },
                                    baseTheme: colorMode === "dark" ? dark : undefined
                                }}
                            />
                            <Box w='full' textAlign='center' fontSize='sm'>
                                <>
                                    By logging in, you agree to our{" "}
                                    <Link
                                        href='https://www.brewlogix.com/privacy-policy/'
                                        className='underline'
                                    >
                                        Privacy Policy
                                    </Link>
                                </>
                            </Box>
                        </SignedOut>
                    </VStack>
                </Center>
            </ClerkLoaded>
            <ClerkLoading>
                <Center className='h-full w-full min-h-full'>
                    <LoginSkeleton />
                </Center>
            </ClerkLoading>
        </LoginWrapper>
    )
}

export default LoginScreen
